import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Translate, useTranslate } from '~/i18n';
import { AngleDownIcon } from '~/svgs/common';
import { expFiltersSelectSortByEvent } from '~/utils/mixpanel-events/experience-filters';
import Dropdown from '../../common/dropdown';

const sortList = [
   // { text: 'most booked' },
   { text: 'magic', value: '' },
   { text: 'popularity', value: 'popularity' },
   { text: 'newest', value: 'latest' },
   { text: 'lowest first', value: 'price' },
   // { text: 'highest first', value: 'high' },
   { text: 'rate', value: 'rating' },
];

const mapValToText = (sortByVal: string) => {
   return sortList.find(({ value }) => sortByVal === value)?.text || 'sort by';
};

type SortProps = {
   sortBy: string;
   // eslint-disable-next-line no-unused-vars
   sortChange: (selected: string) => void;
};

// eslint-disable-next-line no-unused-vars
const SortList = ({ onClick }: { onClick: (value: string) => void }) => {
   return (
      <ul className="text-primary-color">
         {sortList.map(({ value, text }) => (
            <li key={value}>
               <button
                  className="rounded-[23.23px] hover:bg-gray-light py-2.5 px-3 cursor-pointer w-full"
                  onClick={() => {
                     onClick(value);
                  }}>
                  <Translate id={`filters:${text}`} />
               </button>
            </li>
         ))}
      </ul>
   );
};

const SortDropdown = ({ sortBy, sortChange }: SortProps) => {
   const [open, setOpen] = useState(false);
   const [selected, setSelected] = useState(sortBy);
   const { translate } = useTranslate();

   useEffect(() => {
      setSelected(sortBy?.replace('-', ' ') || '');
   }, [sortBy]);

   const close = () => setOpen(false);
   const toggle = () => setOpen(prev => !prev);

   return (
      <Dropdown
         toggler={
            <button
               onClick={toggle}
               className="flex items-center justify-between border px-4 py-1.5 border-primary-disabled rounded-[7px] gap-1.5 focus:bg-gray-50">
               <div>
                  {typeof selected === 'string' &&
                     translate({ id: `filters:${mapValToText(selected)}` })}
               </div>
               <AngleDownIcon />
            </button>
         }
         listClassName="w-[187px] border-0 rounded-default"
         toggleMenu={close}
         open={open}>
         <div className="px-2 py-3.5">
            <SortList
               onClick={value => {
                  setSelected(value);
                  sortChange(value);
                  close();
               }}
            />
         </div>
      </Dropdown>
   );
};
// * Used for bottom sheet
export const BottomSheetSortList = () => {
   const router = useRouter();
   const handleSort = (type: string) => {
      const obj = { ...router.query };

      if (type) {
         obj.sort = type?.split(' ').join('-');
      } else delete obj.sort;
      expFiltersSelectSortByEvent(obj.sort);
      router.push({ query: obj });
   };
   return <SortList onClick={handleSort} />;
};

// * Used for desktop
export const FiltersSort = () => {
   const router = useRouter();
   const handleSort = (type: string) => {
      const obj = { ...router.query };

      if (type) {
         obj.sort = type?.split(' ').join('-');
      } else delete obj.sort;
      expFiltersSelectSortByEvent(obj.sort);
      router.push({ query: obj });
   };

   return (
      <div className="items-center justify-end hidden mb-8 tablet:flex">
         <div className="text-[#ADB5BD] inline px-2 text-[13px]">
            <Translate id="filters:sort by" />
         </div>
         <div className="text-xs">
            <SortDropdown
               sortChange={handleSort}
               sortBy={router.query.sort ? String(router.query.sort) : ''}
            />
         </div>
      </div>
   );
};
